import { Link } from "react-router-dom";
import type { TaskSummary } from "../api/types";
import { formatDate, statusLabel, taskIsDraining, taskProgress } from "../utils/format";
import { Icon } from "./Icon";
import { StatusPill } from "./StatusPill";

interface TaskStatusCardProps {
  task: TaskSummary;
  featured?: boolean;
}

export function TaskStatusCard({ task, featured = false }: TaskStatusCardProps) {
  const progress = taskProgress(task);
  return (
    <article className={`task-card${featured ? " task-card--featured" : ""}`}>
      <div className="task-card__heading">
        <div>
          <span className="eyebrow">任务 #{task.id}</span>
          <h3>{taskIsDraining(task) ? "取消处理中" : statusLabel(task.status)}</h3>
        </div>
        <StatusPill status={taskIsDraining(task) ? "canceling" : task.status} />
      </div>
      <div className="progress-track" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={progress} aria-label={`任务进度 ${progress}%`}>
        <span style={{ width: `${progress}%` }} />
      </div>
      <div className="task-card__metrics">
        <span><b>{progress}%</b> 进度</span>
        <span><b>{task.success_count}</b> 成功</span>
        <span><b>{task.failed_count}</b> 失败</span>
        <span><b>{task.charged_count}</b> 扣分</span>
      </div>
      <div className="task-card__footer">
        <span><Icon name="clock" size={16} />{formatDate(task.created_at)}{task.source_task_id ? <> · 重试自 #{task.source_task_id}</> : null}</span>
        <Link to={`/tasks/${task.id}`} className="text-link">查看详情 <Icon name="arrow" size={16} /></Link>
      </div>
    </article>
  );
}
